module.exports = __webpack_public_path__ + "media/images/partner-7c277de0182e3fd906ce5e0889f56353.png";